export var TEXT_FIELD = 'textField';
export var CHECK_MY_PAPER = 'checkMyPaper';
export var SEE_HOW_IT_WORKS = 'seeHowItWorks';
export var MY_COMPUTER = 'myComputer';
export var GDRIVE = 'gdrive';
export var UPLOAD_OPTIONS_HEADER = 'uploadOptionsHeader';
export var UPLOAD_OPTIONS_SUB_HEADER = 'uploadOptionsSubHeader';